import { addAdminFeatureFlagCustomerSlice } from './add';
import { combineReducers } from 'redux';
import { getAdminFeatureFlagsSlice } from './get';
import { removeAdminFeatureFlagCustomerSlice } from './remove';
import { updateAdminFeatureFlagSlice } from './update';

import { adminFeatureFlagByIdReducers, adminFeatureFlagByIdWatchers } from './_id';
import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';

export const adminFeatureFlagsReducers = combineReducers({
	byId: adminFeatureFlagByIdReducers,
	get: joinReducers([
		addAdminFeatureFlagCustomerSlice.syncReducer,
		getAdminFeatureFlagsSlice.asyncReducers,
		removeAdminFeatureFlagCustomerSlice.syncReducer,
		updateAdminFeatureFlagSlice.syncReducer
	], getAdminFeatureFlagsSlice.asyncState)

});

export const adminFeatureFlagsWatchers = combineAllWatchers([
	adminFeatureFlagByIdWatchers,
	getAdminFeatureFlagsSlice.asyncWatchers
]);
